import type { DemandDriverTypeEnumType } from '@forgd/shared/enums'

export const ecosystemUsers = [
  {
    name: 'Trader',
    description: 'Users who trade.',
    task: 'Trade tokens on the exchange.',
    motivation: 'Profit.',
    valueCreation: 'Pay a fee for trading.',
    desiredBehavior: 'Increase trade volume.',
    incentives: 'Reward for high trade volume.',
    mechanism: 'Pay token rewards to users with the highest trade volume.',
    sideEffect: 'Users might not want to hold token',
  },
  {
    name: 'Liquidity Provider',
    description: 'A user who provides liquidity.',
    task: 'Provide Liquidity for balancers tokens.',
    motivation: 'Profit, Governance rights.',
    valueCreation: 'Provide liquidity.',
    desiredBehavior: 'Provide liquidity for your token over long durations.',
    incentives: 'Pay revenue share.',
    mechanism: 'Pay revenue share and give governance rights to lockers of liquidity token received by providing liquidity for your token.',
    sideEffect: 'Users might be put off by locking for longer durations.',
  },
  {
    name: 'Data Users',
    description: 'Subscribes to information that is published on the network.',
    task: 'Use the data provided through the network.',
    motivation: 'Access to best possible data.',
    valueCreation: 'Pay a fee for access to data.',
    desiredBehavior: 'Access as much data as possible.',
    incentives: 'Reward for more data usage.',
    mechanism: 'Pay the top ranking data users token rewards.',
    sideEffect: 'Token rewards might lead to subsidised non natural growth.',
  },
  {
    name: 'Data Providers',
    description: 'Published information that is published on the network.',
    task: 'Provide accurate and up-to-date data to the network.',
    motivation: 'Profiting from the ability to sell data to a wide variety of subscribers.',
    valueCreation: 'Provide data for the network so it can attract users.',
    desiredBehavior: 'Provide as much accurate data as possible so it attracts as many subscribers as possible.',
    incentives: 'To kickstart the provisioning of data, providers could be incentivised.',
    mechanism: 'Pay initial rewards for provisioning of data.',
    sideEffect: 'Token rewards might dilute the business model and make providers dependent on rewards to stay profitable.',
  },
  {
    name: 'Protocol Builder',
    description: 'Team that builds a blockchain protocol on a baselayer.',
    task: 'Build a compelling product.',
    motivation: 'Profit',
    valueCreation: 'Offer services to users and attract more users to your base layer, increasing transaction volume and the usefulness of the ecosystem.',
    desiredBehavior: 'Build a great product and attract as many users as possible.',
    incentives: 'Reward building on your base layer.',
    mechanism: 'Offer grants to protocols interested in building on your base layer, making it more economically attractive.',
    sideEffect: 'Grants could dilute the sustainability of the project, i.e., without grant, it wouldn\'t have been able to survive.',
  },
  {
    name: 'Yield Farmer',
    description: 'User who is interest in receiving a yield on his investment.',
    task: 'Purchase tokens to collect yield.',
    motivation: 'Recurring profit.',
    valueCreation: 'Provides collateral, stakes, locks or simply holds tokens in return for yield.',
    desiredBehavior: 'Hold tokens as long as possible.',
    incentives: 'Pay an attractive yield.',
    mechanism: 'Pay revenue share and token rewards to token stakers.',
    sideEffect: 'Mercenary behavior where stakers leave when yield drops.',
  },
]

export const demandDriverCategories = [
  {
    id: 'governance',
    label: 'Governance',
    description: 'Hold tokens to vote on governance decisions.',
  },
  {
    id: 'token-buy-backs',
    label: 'Token Buy Backs',
    description: 'Protocol directly purchases tokens with profits made.',
  },
  {
    id: 'staking',
    label: 'Staking',
    description: 'Users stake tokens to earn yield.',
  },
  {
    id: 'locking',
    label: 'Locking',
    description: 'Users lock tokens to earn a yield.',
  },
  {
    id: 'restricted-access',
    label: 'Restricted Access',
    description: 'Holding the token is required to access the protocol\'s products and offerings.',
  },
  {
    id: 'gas-token',
    label: 'Gas Token',
    description: 'Native tokens must be spent to transfer assets or transact on the protocol.',
  },
  {
    id: 'bonding',
    label: 'Bonding',
    description: 'Users are attracted to bond assets by a discount on the token market price.',
  },
  {
    id: 'collateralization',
    label: 'Collateralization',
    description: 'Users can provide their tokens as collateral in return for yield.',
  },
  {
    id: 'network-securing',
    label: 'Network Securing',
    description: 'Node operators stake tokens to secure the network and recieve a yield.',
  },
  {
    id: 'fee-discounts',
    label: 'Fee Discounts',
    description: 'Holders get access to discounted fees when trading or transacting on the protocol.',
  },
  {
    id: 'payment',
    label: 'Payment',
    description: 'The token is used to pay for services of the protocol.',
  },
]

export const demandDriverTypesOptions: Array<{
  id: DemandDriverTypeEnumType
  label: string
  description: string
}> = [
  {
    id: 'mechanism',
    label: 'Mechanism',
    description: 'System driving demand, like staking or token burning.',
  },
  {
    id: 'utility',
    label: 'Utility',
    description: 'The practical use of your token, such as access or rewards.',
  },
]

export const referenceProjectIDs = [
  'band-protocol',
  'bonfida',
  'bonk',
  'basic-attention-token',
  'chainlink',
  'chronos-finance',
  'convex-finance',
  'dydx-chain',
  'gmx',
  'goosefx',
  'gora',
  'helium',
  'hivemapper',
  'hubble',
  'hxro',
  'jet',
  'jito',
  'jupiter-exchange-solana',
  'kamino',
  'lido-dao',
  'looksrare',
  'maker',
  'mango',
  'marinade',
  'metaplex',
  'ocean-protocol',
  'orca',
  'osmosis',
  'pendle',
  'polkadot',
  'psyfi',
  'pyth-network',
  'qredo',
  'radix',
  'saber',
  'solanium',
  'solend',
  'star-atlas',
  'star-atlas-dao',
  'sui',
  'the-graph',
  'the-sandbox',
  'thorchain',
  'tulip-protocol',
  'uniswap',
  'yearn-finance',
]
